<template>    
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <FormInput class="col-12" label="Nombre" name="Nombre" rules="required" v-model="voucher.name" />
            <FormInput class="col-6" label="Descuento (%)" name="Descuento (%)" type="number" v-model="voucher.discount_percent" :disabled="voucher.discount_fixed != 0" />
            <FormInput class="col-6" label="Descuento (€)" name="Descuento (€)" type="number" v-model="voucher.discount_fixed"  :disabled="voucher.discount_percent != 0" />
            <FormInput class="col-6" label="Código" name="Código" rules="required" v-model="voucher.code" />
            <FormInput class="col-6" label="Usos" name="Usos" rules="required" type="number" v-model="voucher.units" />
            <FormMultiselect 
                class="col-12"
                label="Precios"
                name="Precios"
                option-label="descripcion"
                track-by="id"
                :options="precios"
                :multiple="true"
                :close-on-select="false"
                v-model="voucher.prices"
            />
            <b-col cols="12" class="mb-2">
                <b-checkbox v-model="voucher.sin_vincular">El cupón será válido sin necesidad de vincularlo a ninguna zona ni tipo de abono</b-checkbox>
            </b-col>
            <b-col cols="12">
                <b-button type="submit">
                    Continuar
                </b-button>
            </b-col>            
        </div>
    </ValidationObserver>
</template>

<script setup>
    import { ref, computed, onMounted, getCurrentInstance } from 'vue';
    import FormMultiselect from '@/modules/ui/MultiselectCustom.vue';

    const props = defineProps({
        voucher: {
            type: Object,
            default: () => ({})
        }
    });

    const emit = defineEmits(['terminado']);

    const observer = ref(null);
    const precios = ref([]);

    const instance = getCurrentInstance();
    const store = instance.proxy.$store;
    const config = instance.proxy.config;

    const lista = computed(() => store.getters.getListaId);

    const submit = async() => {
        const isValid = await observer.value.validate();
        if (isValid) {
            emit('terminado');
        }
    };

    const getPrecios = () => {
        const params = {
            lista_id: lista.value
        };

        store.dispatch(config.getVuexAlias('back.lista.vouchers.precios.disponibles'), params).then(res => {
            precios.value = res.data.data;
        });
    };

    onMounted(() => {
        getPrecios();
    });
</script>